import React, { useState } from "react";

// ===================== React Router DOM ====================== //
import { Link, useNavigate } from "react-router-dom";

// ===================== Routes ====================== //
import { login } from "../routes/routesDefined";

// ===================== Material Tailwind ====================== //
// import Modal from "@material-tailwind/react/Modal";
// import ModalHeader from "@material-tailwind/react/ModalHeader";
// import ModalBody from "@material-tailwind/react/ModalBody";

// ===================== Images ====================== //
import { images } from "../assets/styles/Images";

// ===================== Lotties ====================== //
import Lottie from "react-lottie";
import successData from "../assets/lotties/success-animation";

// ===================== Scroll ====================== //
import { scroll } from "../helperFunctions/scroll";
import axios from "axios";
import { baseUrl } from "../utils/config";
import ApiServices from "../api/services";
import { useLoggedContext } from "../context/provider";

const ForgotPassword = () => {
  let navigate = useNavigate();

  const { openSuccessModal } = useLoggedContext();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordModal, setPasswordModal] = useState({
    show: false,
    message: "",
  });

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = { email: email };

    ApiServices.auth
      .forgotPassword(payload)
      .then((response) => {
        if (response.data.code === 200) {
          setLoading(false);
          openSuccessModal({
            title: "Success!",
            message: response.data.message,
            onPress: (close) => {
              close();
              // navigate("/" + login, { replace: false });
              window.location.href = "https://edufeel.co.uk";
            },
          });
          setEmail("");
        } else {
          setLoading(false);
          setError("Invalid User");
        }
      })
      .catch((error) => {
        setError(error.response.data.message);
        setLoading(false);
      });
  };

  const handleForgetInput = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: successData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="relative flex h-screen overflow-hidden bg-white">
      <div className="h-screen w-full bg-white px-6 sm:px-8 md:px-16 lg:w-1/2">
        <div className="mx-auto flex h-full w-full flex-col justify-center sm:w-[70%] 2xl:w-[60%]">
          <h4 className="d-flex mb-8 w-full text-center text-xl font-bold uppercase tracking-wider text-white text-primary lg:text-start 2xl:mb-12">
            <img src={images.NewLogo} alt="edufeel Social Logo" className="mx-auto w-[15rem] lg:mx-0 2xl:w-[19.4rem]" />
          </h4>
          <div>
            <div className="text-grayColor500 mb-2 text-center text-lg font-semibold leading-tight lg:text-start 2xl:text-xl">
              Forgot your password?
            </div>
            <p className="text-md mb-8 text-center font-normal leading-normal text-grayColor300 lg:mb-10 lg:text-start lg:leading-snug 2xl:mb-12">
              Enter your email below and receive a password reset link.
            </p>
          </div>
          <form onSubmit={handleFormSubmit} className="mx-auto w-full">
            <div>
              <input
                value={email}
                onChange={handleForgetInput}
                type="email"
                className={`text-md text-grayColor500 mb-3 w-full rounded-full border border-grayColor100 p-3 px-5 leading-normal outline-none transition duration-150 ease-in-out md:p-3.5 md:px-6 lg:text-base 2xl:leading-loose`}
                id="email"
                placeholder="Email Address"
                required
                autoComplete="off"
              />

              {error.length >= 1 && <span className="mb-8 pl-2 text-red-500">{error}</span>}
            </div>
            <div className="text-right">
              {loading ? (
                <p className="forgot-password text-base font-medium text-gray-500 underline lg:text-base 2xl:text-lg">Back to Login?</p>
              ) : (
                <Link className="forgot-password text-grayColor500 font-medium underline" to={"/" + login}>
                  Back to Login?
                </Link>
              )}
            </div>

            <div className="mt-5 flex items-center justify-center lg:mt-6 2xl:mt-10">
              <button
                className={`w-full rounded-full bg-secondary py-4 px-4 text-base font-medium leading-normal text-white shadow-md xl:text-lg 2xl:leading-loose `}
              >
                {!loading && <span>Send</span>}
                {loading && (
                  <svg
                    role="status"
                    className="inline h-6 w-6 animate-spin fill-gray-600 text-gray-200"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="hidden h-screen w-full bg-white sm:p-8 lg:block lg:w-1/2 lg:p-8 2xl:p-16">
        <img src={images.authImgSvg} className="ml-auto h-full w-full rounded-3xl object-cover" style={{ objectPosition: "50% 5%" }} alt="member" />
      </div>
    </div>
  );
};

export default ForgotPassword;
